// core dependencies
import React from 'react';
import Media from 'react-responsive';
import propTypes from 'prop-types';
// custom helpers & utils
import styled from 'styled-components';
import * as leadDicts from 'dicts/leads';
import {FormattedMessage, FormattedDate} from '@meiko/react-intl';
import {screenMdMin} from 'styles/constants';
import {getLeadEncounterState} from 'utils/leads';

// components
import LinkButton from 'components/generic/LinkButton';
import Icon from 'components/generic/Icon';

const largeQuery = `(min-width: ${screenMdMin})`;
const Progress = styled.span`
	white-space: nowrap;
`;

const StyledLinkButton = styled(LinkButton)`
	margin-left: 10px;
	@media (min-width: ${screenMdMin}) {
		margin-left: 20px;
	}
`;

const dateTimeFmtOpts = {
	day: 'numeric',
	month: 'numeric',
	year: 'numeric',
};

const getIconName = type => {
	switch (type) {
		case 'socialMediaLead':
			return 'calendar';
		default:
			return 'phone';
	}
};

const getMessageType = type => {
	switch (type) {
		case 'socialMediaLead':
			return 'Go to team calendar';
		default:
			return 'Go to call';
	}
};

const StyledLink = ({lead, navigateTo}) => {
	return (
		<StyledLinkButton onClick={() => navigateTo(lead)}>
			<Icon name={getIconName(lead.type)} />
			&nbsp;
			<Media query={largeQuery}>
				<FormattedMessage id={getMessageType(lead.type)} />
			</Media>
		</StyledLinkButton>
	);
};

const ProgressTd = ({lead, noDate = false, navigateTo, showCallButton}) => {
	return (
		<td>
			{!lead.buildingId ? (
				<FormattedMessage id="Waiting for building" />
			) : lead.encounterState ? (
				<>
					{!noDate && (
						<>
							<FormattedDate value={new Date(lead.updatedAt)} {...dateTimeFmtOpts} />
							{' - '}
						</>
					)}
					<FormattedMessage id={leadDicts.type[lead.encounterType]} />
					{' - '}
					<FormattedMessage id={getLeadEncounterState(lead)} />
					{showCallButton && lead.status === 'cancelledVisit' && (
						<StyledLink lead={lead} navigateTo={navigateTo} />
					)}
				</>
			) : (
				<Progress>
					{!noDate && (
						<>
							<FormattedDate value={new Date(lead.createdAt)} {...dateTimeFmtOpts} />
							&nbsp;-&nbsp;
						</>
					)}
					<FormattedMessage id="Waiting for contact" />
					{noDate && showCallButton && <StyledLink lead={lead} navigateTo={navigateTo} />}
				</Progress>
			)}
		</td>
	);
};

ProgressTd.propTypes = {
	lead: propTypes.object,
	noDate: propTypes.bool,
	navigateTo: propTypes.func,
	showCallButton: propTypes.bool,
};

export default ProgressTd;
